import {EnableRecordButton} from '../buttons/EnableRecordButton.tsx';
import {DisableRecordButton} from '../buttons/DisableRecordButton.tsx';
import {
    AccountApplication,
    AccountApplicationStatus,
} from '../../account-applications/types';
import {Application} from '../types.ts';

// FNP-2070: only an ACTIVE record is an enabled application. An INACTIVE or
// no-status record gets Enable, which reactivates that same record in place
// (console-api, FNP-902). Matching on applicationId alone left a Disabled
// application showing Disable forever.
export const EnableToggle = ({
                                 application,
                                 accountApplications,
                             }: {
    application: Application,
    accountApplications?: AccountApplication[],
}) => {
    const active = accountApplications?.find(
        (item) => item.applicationId === application.id
            && item.accountApplicationStatus === AccountApplicationStatus.ACTIVE,
    );

    return active ? <DisableRecordButton record={active}/> : <EnableRecordButton record={application}/>;
};
